import { SET_INITIAL_DATA } from '../constants';

export const setInitialData = data => {
	return { type: SET_INITIAL_DATA, ...{ data } };
};
